import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/482'

const ActiveCustomersAtSelectLocationsTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="looker.urls.dashboards/482"
  />
)

export default ActiveCustomersAtSelectLocationsTab
